import AppActions from '../../actions/app';
import LeadActions from '../../actions/lead';
import { EMAIL_DUP_PUPS_ERROR_MESSAGE } from '../../constants/common';
import { genericFireAction } from './util';

export default (store) => (next) => (action) => {
    // Guard against null/undefined actions or non-action objects (like Promises)
    if (!action || typeof action !== 'object' || !action.type) {
        return next(action);
    }

    let actionGenerator;

    switch (action.type) {
    case AppActions.CREATE_ACCOUNT_FAIL:
        if (action.error === EMAIL_DUP_PUPS_ERROR_MESSAGE) {
            actionGenerator = LeadActions.setEmailValidationError;
            genericFireAction(store, actionGenerator, action.error);
        }
        break;
    default:
        break;
    }
    return next(action);
};
